import { type ContentObjectDetail, type ContentObjectList, isGroupContentObject } from 'models';

export const canLikeContentObject = ({ contentObject }: { contentObject: ContentObjectDetail | ContentObjectList }) => {
  if (isGroupContentObject(contentObject)) {
    return true;
  }

  if (contentObject.contentableType !== 'Community') {
    // TODO: Program here
    return false;
  }

  return contentObject.postInCommunities[0].settings.viewMembers;
};
